import { call, put, takeLatest } from 'redux-saga/effects';
import {
  unityEPGService,
  unityContentsService,
} from '@tbx/experience-widgets-lib';

import * as actions from './actions';
import { types } from './constants';

function* fetchEPGDataByIds(action) {
  const { unityToken, epgID, from, to, epgUrl } = action;
  try {
    const { result } = yield call(
      unityEPGService.fetchEPGDataByIds,
      unityToken,
      {
        epgID,
        from: from.toISOString(),
        to: to.toISOString(),
      },
      epgUrl,
    );

    if (!result || result.error) {
      throw new Error(result);
    } else {
      yield put(actions.setEpgDataByIdsSuccess(result));
    }
  } catch (e) {
    const errObj = e.error ? e.error : e;
    console.error('FETCH_EPG_DATA_BY_IDS_ERROR: ', errObj);
    yield put(actions.setEpgDataByIdsError(errObj));
  }
}

function* fetchCategories(action) {
  const { unityToken } = action;

  try {
    const { result } = yield call(
      unityContentsService.getCategories,
      unityToken,
      {},
    );

    if (!result || result.error) {
      throw new Error(result);
    } else {
      yield put(actions.setCategoriesSuccess(result));
    }
  } catch (e) {
    const errObj = e.error ? e.error : e;
    console.error('FETCH_CATEGORIES_ERROR: ', errObj);
    yield put(actions.setCategoriesError(errObj));
  }
}

function* contentChange() {
  try {
    yield put(actions.clearErrors());
  } catch (e) {
    const errObj = e.error ? e.error : e;
    console.error('clearErrorsContentChange: ', errObj);
  }
}

function* saga() {
  /* yield takeLatest(types.WIDGET_FETCH, fetchContentWidget); */
  yield takeLatest(types.FETCH_EPG_DATA_BY_IDS, fetchEPGDataByIds);
  yield takeLatest(types.FETCH_CATEGORIES, fetchCategories);
  yield takeLatest(types.WIDGET_CHANGE, contentChange);
}

export default saga;
